import guardRaptureUrl from './guardRaptureUrl';
// 主要用来处理路由跳转前后的操作
// 使用消息传递
class EventEmitter {
    constructor() {
        this.isCapture = false;
        this.to = null;
        this.from = null;
        this.next = null;
        this.queue = {};
        this.routerRaptureSign = ['routerRapture'];
    }
    on(fnName, fn) {
        fn && (this.queue[fnName] = fn);
    }
    emit(fnName) {
        return this.queue[fnName]();
    }
    remove(fnName) {
        this.queue[fnName] = null;
    }
    clear() {
        this.queue = {};
    }
}
let emitter = new EventEmitter();
createProperty('to');
function createProperty(attr) {
    // 转为双向绑定路由属性
    Object.defineProperty(emitter, attr, {
        set(val) {
            if (!this.from || val.name === this.from.name) {
                this.next();
            }
            else {
                guardRaptureUrl(emitter, this.next);
            }
        },
    });
}
export default emitter;
